import React from 'react';
import { SKIPS, EMPTY_SKIP, GET_TOGETHER, anySkipped, isGetTogether, skipHint, normalizeSkip } from './plannerSkips';
import { C } from '../portalkit';

/**
 * WHAT SHOULD IT HANDLE? — a #FAFAFA box on the prompt card: a preset segmented pill (FULL PARTY /
 * JUST A GET-TOGETHER) and one 34px toggle per thing the planner can leave out. On = black with a
 * green ✓ dot; off = white, struck through, a grey × dot. `aria-pressed` says which is which.
 */
/** A 34px on/off pill: on = black with a green ✓ dot; off = white, struck through, a grey × dot. */
export function TogglePill({ on, label, onClick, disabled, testId, ...rest }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} aria-pressed={on} data-testid={testId} className="pk" style={{ display: 'flex', alignItems: 'center', gap: 7, height: 34, padding: '0 14px 0 10px', border: 'none', borderRadius: 999, background: on ? '#000' : '#fff', color: on ? '#fff' : C.gray400, fontSize: 10, fontWeight: 700, letterSpacing: '.12em', cursor: 'pointer', textTransform: 'uppercase', transition: 'background-color .2s, color .2s', boxShadow: on ? 'none' : `inset 0 0 0 1px ${C.skeleton}` }} {...rest}>
      <span aria-hidden="true" style={{ width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 999, background: on ? C.green : C.skeleton, color: on ? '#fff' : C.gray400, fontSize: 10, lineHeight: 1 }}>{on ? '✓' : '×'}</span>
      <span style={{ textDecoration: on ? 'none' : 'line-through' }}>{label}</span>
    </button>
  );
}

export default function SkipControls({ skip, onChange, disabled = false }) {
  const s = normalizeSkip(skip);
  const full = !anySkipped(s);
  const gt = isGetTogether(s);
  const preset = (label, on, next) => (
    <button key={label} type="button" onClick={() => onChange(next)} disabled={disabled} aria-pressed={on} className="pk" style={{ height: 28, padding: '0 12px', border: 'none', borderRadius: 999, background: on ? '#000' : 'transparent', color: on ? '#fff' : C.gray500, fontSize: 9, fontWeight: 700, letterSpacing: '.14em', cursor: 'pointer', whiteSpace: 'nowrap', textTransform: 'uppercase', transition: 'background-color .2s, color .2s' }}>{label}</button>
  );
  return (
    <div data-testid="skip-controls" style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '14px 16px', borderRadius: 18, background: C.waiting, boxShadow: `inset 0 0 0 1px ${C.skeleton}` }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '8px 12px' }}>
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase' }}>WHAT SHOULD IT HANDLE?</span>
        <div role="group" aria-label="Preset" style={{ display: 'flex', gap: 2, padding: 3, borderRadius: 999, background: C.skeleton }}>
          {preset('FULL EVENT', full, { ...EMPTY_SKIP })}
          {preset('JUST A GET-TOGETHER', gt, { ...GET_TOGETHER })}
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {SKIPS.map(({ key, label }) => (
          <TogglePill key={key} label={label} on={!s[key]} onClick={() => onChange({ ...s, [key]: !s[key] })} disabled={disabled} data-skip={key} />
        ))}
      </div>
      <span style={{ fontSize: 11, lineHeight: 1.55, color: C.gray500 }}>{skipHint(s)}</span>
    </div>
  );
}
